import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { getMisc } from "../../../../apiclients/streamsapi_bridge";

function NumbersAreaService({
  register,
  errors,
  watch,
  setValue,
  clearErrors,
  areaOfServiceDetails,
  setareaOfServiceDetails,
  reloadarea,
  setreloadarea,
  areaErrors,
  setAreaErrors
}) {
  const navigate = useNavigate();
  const [areaOfService, setareaOfService] = useState([]);
  const [areaServiceList, setareaServiceList] = useState([]);
  const [selectAllArea, setselectAllArea] = useState(-1);
  const [executeFlag, setexecuteFlag] = useState(true);

  useEffect(() => {
    if (
      (areaOfServiceDetails &&
        areaOfServiceDetails.length > 0 &&
        executeFlag) ||
      reloadarea ||
      areaErrors
    ) {
      // alert("jhdgfdfh");
      setexecuteFlag(false);
      setreloadarea(false);

      // setareaServiceList(areaOfServiceDetails);
      if (areaErrors && areaErrors.length > 0) {
        const updateerror = [...areaOfServiceDetails];
        areaErrors.forEach((error) => {
          const { param_name, message, position } = error;
          if (param_name.split(".").length > 0 && updateerror[position]) {
            const fieldName = param_name.split(".")[1] + "error";
            updateerror[position][fieldName] = message;
          }
        });
        setareaServiceList(updateerror);
      } else {
        setareaServiceList(areaOfServiceDetails);
      }
      // setareaOfServiceDetails(areaOfServiceDetails);
    }
  }, [areaOfServiceDetails, executeFlag, reloadarea, areaErrors]);

  async function fetchAreaOfService() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["port_area_of_service"] }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log(
      "port_area_of_service :::::::::::::::::::::::::::::::::::::::::::::::::::::: " +
      JSON.stringify(tdata)
    );

    setareaOfService(tdata.misc.port_area_of_service);
  }

  useEffect(() => {
    fetchAreaOfService();
  }, []);

  function handleAllServiceChange(value) {
    // clearErrors();
    setselectAllArea(parseInt(value));
    const updateArea = areaServiceList.map((area) => {
      const { area_of_serviceerror, ...rest } = area;
      return {
        ...rest,
        area_of_service: parseInt(value),
      };
    });
    setAreaErrors([]);
    setareaServiceList(updateArea);
    setexecuteFlag(false);
    setareaOfServiceDetails(updateArea);
    setValue("area_of_service", updateArea, { shouldDirty: true });
  }

  function handleChangeService(value, number) {
    const index = areaServiceList.findIndex((area) => area.tfn_num === number);
    const updateArea = areaServiceList.map((area) => {
      if (area.tfn_num === number) {
        const { area_of_serviceerror, ...rest } = area;
        return {
          ...rest,
          area_of_service: parseInt(value),
        };
      }
      return area;
    });
    setAreaErrors(areaErrors.filter((error) => error.position === index));
    setareaServiceList(updateArea);
    setexecuteFlag(false);
    setareaOfServiceDetails(updateArea);
    setValue("area_of_service", updateArea, { shouldDirty: true });
  }
  return (
    <>
      <div className="pb-3">
        <h5>Area of Service</h5>
        <div className="d-flex align-items-center">
          <div className="tel-numbers mt-2 w-20">
            <strong>Toll Free Number(s)</strong>
          </div>
          <div className="tel-numbers mt-2">
            <strong>Area of Service*</strong>
          </div>
        </div>

        <div className="d-flex align-items-center">
          <div className="mt-4 w-20">Set for All Numbers</div>
          <div className="w-20">
            <select
              className="form-select"
              value={selectAllArea}
              onChange={(e) => {
                e.preventDefault();
                handleAllServiceChange(e.target.value);
              }}
            >
              <option value={-1}>Select Area of Service</option>
              {areaOfService &&
                Object.entries(areaOfService).length > 0 &&
                Object.entries(areaOfService).map(([key, value]) => (
                  <option value={value}>{key}</option>
                ))}
            </select>
          </div>
        </div>
        <div style={{ overflowY: "auto", maxHeight: "calc(100vh - 320px)" }}>
          {areaServiceList &&
            areaServiceList.length > 0 &&
            areaServiceList.map((area) => (
              <div className="d-flex align-items-center">
                <div className="mt-4 w-20">{area.tfn_num}</div>
                <div className="w-20">
                  <select
                    className="form-select"
                    value={area.area_of_service}
                    onChange={(e) => {
                      e.preventDefault();
                      handleChangeService(e.target.value, area.tfn_num);
                    }}
                  >
                    <option value={-1}>Select Area of Service</option>
                    {areaOfService &&
                      Object.entries(areaOfService).length > 0 &&
                      Object.entries(areaOfService).map(([key, value]) => (
                        <option value={value}>{key}</option>
                      ))}
                  </select>
                  {area?.area_of_serviceerror && (
                    <p className="text-danger">{area?.area_of_serviceerror}</p>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}

export default NumbersAreaService;
